
class ShapeFillSeriesArgs {
    // curveCount - The number of initial outer curves to create and work
    //              with using the subsequent arguments. 
    // startParam - The param (i) to center the first curve set. Will 
    //                 Auto locate the rest. 
    // maxLayers - how many rings to add on.  
    // thickness - Thickness as a percent of the parent (will use the
    //             radius, be a percent of that)
    //             Positive thickness grows outward, negative thickness inward.
    // coverage - How much of the shape the curves should cover 
    //            at the first layer.  
    //
    //
    //// Change or adjustment parameters
    // change - How quickly to shink or grow those rings.  
    //          A percent change. Replaces attenuate since it can grow 
    //          or shrink.  
    //          Is added to 1, so usually a small negative or positive that will
    //          shrink or grow respectively.  
    // rotation - Optional argument to shift the layers moving outward. 
    //            Unlike change does not alter the size, it adjusts position
    //            rotationally. Positive is counterclock, negative clockwise. 
    // spacing - Add spacing between layers, uses same calculations
    //           as thickness
    // sizeFactors - A sequence of size adjustments to repeat
    //              They will apply to all curves in that layer.
    //              TODO: This is not actually implemented
    // smooth - Instead of stacking square layers will seek to smooth the 
    //          transition by connecting inner of current layer
    //          with inner of next layer
    constructor(
        curveCount,
        startParam,
        maxLayers,
        thickness,
        coverage,
        centerPt
    ) {
        this.curveCount = curveCount
        this.startParam = startParam
        this.maxLayers = maxLayers
        this.thickness = thickness
        this.coverage = coverage
        this.centerPt = centerPt

        this.change = 0
        this.changeCompound = true
        this.rotation = 0
        this.spacing = 0
        this.subSizes = [1]
        this.sizeFactors = [1, 1]
        this.smooth = false
    }

    setChange(change) {
        this.change = change
        return this
    }

    setChangeCompound(compound) {
        this.changeCompound = compound
        return this
    }

    setSpacing(spacing) {
        this.spacing = spacing
        return this
    }

    setRotation(rotation) {
        this.rotation = rotation
        return this
    }

    setSubSize(subSizes) {
        this.subSizes = subSizes
        return this
    }

    setSmooth(smooth) {
        this.smooth = smooth
        return this
    }

    setSizeFactors(sizeFactors) {
        this.sizeFactors = sizeFactors
        return this
    }
}

export { ShapeFillSeriesArgs }
